var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpenGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5569 11.9999C14.5569 13.4201 13.4057 14.5713 11.9855 14.5713C10.5653 14.5713 9.41406 13.4201 9.41406 11.9999C9.41406 10.5797 10.5653 9.42847 11.9855 9.42847C13.4057 9.42847 14.5569 10.5797 14.5569 11.9999Z",
    stroke: "#ACACAC",
    strokeWidth: 1.71429
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65659 7.75736C9.99974 5.41421 13.7988 5.41421 16.1418 7.75736L17.9602 9.57564C19.103 10.7185 19.6745 11.29 19.6745 12C19.6745 12.7101 19.103 13.2815 17.9602 14.4244L16.1418 16.2426C13.7988 18.5858 9.99974 18.5858 7.65659 16.2426L5.83831 14.4244C4.69545 13.2815 4.12402 12.7101 4.12402 12C4.12402 11.29 4.69545 10.7185 5.83831 9.57564L7.65659 7.75736Z",
    stroke: "#ACACAC",
    strokeWidth: 1.71429,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenGray);
export default __webpack_public_path__ + "static/media/eye_open_gray.da8252ff638d8031b078a25391f67ed2.svg";
export { ForwardRef as ReactComponent };